import { render, staticRenderFns } from "./NewHirePortal.vue?vue&type=template&id=21c1f024&scoped=true"
import script from "./NewHirePortal.vue?vue&type=script&lang=js"
export * from "./NewHirePortal.vue?vue&type=script&lang=js"
import style0 from "./NewHirePortal.vue?vue&type=style&index=0&id=21c1f024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1f024",
  null
  
)

export default component.exports